"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
achieve
admire
amuse
applaud
approve
ask
assess
assign
assume
attack
ban
banish
battle
become
believe
bite
boil
build
burn
bury
buy
call
carry
chain
chase
cheat
check
cheer
chew
chill
chop
clean
coach
comb
compare
compete
cook
copy
cover
crash
create
cross
defeat
defy
deliver
deny
design
destroy
develop
doubt
draw
dream
dress
drive
drop
eat
edit
end
enjoy
envy
erase
expect
explain
explode
fail
fake
fetch
fight
film
find
fix
fly
fold
follow
fry
fume
fuse
give
grab
greet
hammer
heal
hear
help
hide
honour
hug
hunt
impress
inhale
invent
invite
ionize
itch
join
judge
juggle
kick
kill
kiss
know
learn
leave
lick
lose
love
lull
lure
mail
make
marry
meet
melt
mix
mock
move
nail
name
notice
obey
oppose
own
patch
pay
perform
play
poke
pop
promise
protect
provide
pull
punch
push
quote
raise
reach
read
refuse
relax
remember
repair
reply
rescue
retire
roll
ruin
rule
rush
save
search
see
sell
send
serve
shake
share
shave
shop
slay
smash
smell
snuggle
soak
study
suffer
swat
take
taste
teach
tease
tell
thank
tickle
tie
trade
train
try
unite
use
visit
walk
warn
wash
watch
weaken
widen
win
wrap
yell
`
    .trim()
    .split(/\s+/);
//# sourceMappingURL=verbs.js.map